import React, { Component } from 'react';
import './Home.scss';
import Card from '../Portfolio/Card/Card.js';

import in_a_week_cover from '../../../images/in_a_week/in_a_week_cover.jpg';
import night_flight_cover from '../../../images/night_flight/night_flight_cover.jpg';
import rebirth_cover from '../../../images/rebirth/rebirth_cover.jpg';
import rebirth_cover_2 from '../../../images/rebirth/cover_2.jpg';

import trend_2020_cover from '../../../images/trend_2020/trend portfolio COVER.png';

class Home extends Component {
  constructor(props) {
    super(props);
    this.selectProject = this.selectProject.bind(this);
  }

  selectProject(e, project) {
    this.props.changePage(e, "Portfolio");
    this.props.changeProject(e, project);
    window.scrollTo(0, 68); //the height of the nav-bar
  }

  render() {
    return (
      <div className='Home'>
        <Card type={"image"} row={[1, 2]} column={[1, 12]}
              image={rebirth_cover_2}/>

        <Card  id="portfolio-header" type={"header-2"} row={3} column={[1, 12]}
              contents={"Knitwear Design"} />

        <Card type={"image-link"} row={4} column={[1, 4]}
              image={rebirth_cover}
              onClick={e => this.selectProject(e, "rebirth")}/>
        <Card type={"text-centered"} row={5} column={[1, 4]}
              contents={"Rebirth | 2019"} />

        <Card type={"image-link"} row={4} column={[5, 8]}
              image={in_a_week_cover}
              onClick={e => this.selectProject(e, "in_a_week")}/>
        <Card type={"text-centered"} row={5} column={[5, 8]}
              contents={"In A Week | 2019"} />

        <Card type={"image-link"} row={4} column={[9, 12]}
              image={night_flight_cover}
              onClick={e => this.selectProject(e, "night_flight")}/>
        <Card type={"text-centered"} row={5} column={[9, 12]}
              contents={"Night Flight | 2018"} />


        <Card type={"header-2"} row={6} column={[1, 12]}
              contents={"Trend Portfolio"} />

        <Card type={"image-link"} row={7} column={[1, 12]}
              image={trend_2020_cover}
              onClick={e => this.selectProject(e, "trend_2020")}/>
        <Card type={"text-centered"} row={8} column={[5, 8]}
              contents={"Trend Portfolio | 2020"} />


        <Card id="about-header" type={"header"} row={9} column={[4, 9]} contents={"About"} />
        <Card type={"text"} row={10} column={[4, 9]}
              contents={<>
                          Beth Simmons is a graduate knitwear designer from Winchester School of Art, specialising in womenswear. Beth is currently based between Warwickshire and London.
                          <br />
                          <br />

                          During her degree, she has developed skills on dubied and domestic knitting machines, as well as developing designs for Shima Seiki.
                          <br />
                          <br />
                          Achievements include receiving the Framework Knitters company bursary award, selling swatches through Bobble swatching company, and exhibiting at Premiere Vision, Spinexpo Paris, and Spinexpo Shanghai.
                        </>
                      } />
      </div>
    );
  }
}

export default Home;
